<template>
  <div v-if="isOpen" class="bg-green flex items-center font-medium h-40 max-sm:h-30">
    <div class="container text-center text-body-sm text-body-sm-mobile text-blue" v-html="content"></div>
    <!-- <button aria-label="Close" @click="close">X</button> -->
  </div>
</template>

<script>
export default {
  name: "AnnouncementBar",
};
</script>

<script setup>
import {toRefs, ref} from "vue";

const props = defineProps({
  visible: {
    type: Boolean,
    required: false,
    default: true,
  },
  content: {
    type: String,
    required: true,
  },
});

const {visible, content} = toRefs(props);

const isOpen = ref(visible.value);

const close = () => (isOpen.value = false);
</script>
